import React, { useCallback, useEffect, useState, useMemo } from 'react';
import moment from 'moment';

import { Button, Table, Space, Form, Popconfirm, Popover, Select } from 'antd';
import { DeleteFilled, ImportOutlined } from '@ant-design/icons';

import './softwarePage.sass';

const Option = Select.Option;

const SoftwareTable = ({ software, deleteSoftware, users, devices, setSoftwareToClient }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState(software?.Data);
  const [selectedDeviceId, setSelectedDeviceId] = useState(undefined);
  const [applyLoading, setApplyLoading] = useState(false);
  const [templatePopupVisibility, setTemplatePopupVisibility] = useState(undefined);

  useEffect(() => {
    if (software?.Data) setData(software.Data);
  }, [software]);

  const removeSoftware = useCallback((record) => deleteSoftware(record.ID), [deleteSoftware]);

  const setSoftwareAction = useCallback(
    (softwareId) => {
      setApplyLoading(true);
      setSoftwareToClient(selectedDeviceId, softwareId)
        .then(() => {
          setApplyLoading(false);
          setSelectedDeviceId(undefined);
          setTemplatePopupVisibility(undefined);
        })
        .catch(() => setApplyLoading(false));
    },
    [selectedDeviceId, setSoftwareToClient],
  );

  const selectDevice = useCallback((deviceId) => setSelectedDeviceId(deviceId), []);

  const columns = useMemo(() => {
    return [
      {
        title: 'File Name',
        dataIndex: 'FileName',
        editable: false,
        width: 120,
      },
      {
        title: 'File Path',
        dataIndex: 'FilePath',
        editable: false,
        width: 120,
      },
      {
        title: 'User',
        dataIndex: 'UserId',
        editable: false,
        width: 170,
        render: (id) => {
          const index = users?.Data?.findIndex((user) => user.ID === id);
          if (index && index !== -1) {
            return <div>{users?.Data[index]?.username}</div>;
          }
        },
      },
      {
        title: 'Hash',
        dataIndex: 'Hash',
        editable: false,
        width: 500,
        render: (hash) => <span style={{ wordBreak: 'break-all' }}>{hash}</span>,
      },
      {
        title: 'Created At',
        dataIndex: 'CreatedAt',
        editable: false,
        render: (time) => <div>{moment(time).format('DD-MM-YYYY HH:mm')}</div>,
        width: 200,
      },
      {
        title: 'Operations',
        dataIndex: 'operations',
        width: 150,
        render: (_, record) => (
          <Space size="small">
            <Popconfirm title={'Sure delete Template ID: ' + record.ID + '?'} onConfirm={() => removeSoftware(record)}>
              <Button type="text" icon={<DeleteFilled />} />
            </Popconfirm>
            <Popover
              placement="left"
              title="Set Software to Device"
              visible={templatePopupVisibility === record.ID}
              onVisibleChange={(e) =>
                e ? setTemplatePopupVisibility(record.ID) : setTemplatePopupVisibility(undefined)
              }
              content={
                <div>
                  <Select
                    placeholder="Select Device"
                    style={{ width: 300 }}
                    onChange={selectDevice}
                    value={selectedDeviceId}
                  >
                    {devices?.map((device) => (
                      <Option key={device.ID} value={device.DeviceID}>
                        {device.DeviceID} - {device.DeviceName}
                      </Option>
                    ))}
                  </Select>
                  <Button
                    style={{ marginLeft: 10 }}
                    onClick={() => setSoftwareAction(record.ID)}
                    loading={applyLoading}
                  >
                    Apply
                  </Button>
                </div>
              }
              trigger="click"
            >
              <Button type="text" icon={<ImportOutlined />} />
            </Popover>
          </Space>
        ),
      },
    ];
  }, [
    applyLoading,
    devices,
    removeSoftware,
    selectedDeviceId,
    setSoftwareAction,
    templatePopupVisibility,
    users,
    selectDevice,
  ]);

  return (
    <div className="templates-table">
      <Form className="templates-table__form" form={form} component={false}>
        <Table
          className="templates-table__table"
          size="small"
          dataSource={data}
          columns={columns}
          // pagination={{
          //   onChange: cancel,
          // }}
          rowKey={'ID'}
          expandable={{
            expandedRowRender: (record) => {
              return (
                <div className="templates-table__table_expand-wrapper">
                  <pre>{JSON.stringify(record, null, 2)}</pre>
                </div>
              );
            },
          }}
        />
      </Form>
    </div>
  );
};

export default SoftwareTable;
